import React, { useCallback, useState } from 'react';
import { ItemCircleState, ItemCircleStateProps } from './ItemCircleState';
import ModalFullScreen from '../../../ModalFullScreen/ModalFullScreen';
import Modal, { ModalProps } from '../../../Modal/Modal';

export type CycleCircleStateModalSize = 'minimized' | 'fullscreen';

type StateModalProps = Pick<CycleCircleState, 'modalSize'> & ModalProps;

export interface CycleCircleState {
  circleProps: ItemCircleStateProps;
  modalTitle?: string;
  children?: React.ReactNode;
  modalSize?: CycleCircleStateModalSize;
}

const StateModal = ({ modalSize, children, ...props }: StateModalProps) => {
  if (modalSize === 'minimized') {
    return <Modal {...props}>{children}</Modal>;
  }

  if (modalSize === 'fullscreen') {
    return <ModalFullScreen {...props}>{children}</ModalFullScreen>;
  }

  return null;
};

export const CycleCircleState = ({ circleProps, modalSize, modalTitle, children }: CycleCircleState) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  return (
    <div className="c-cycle-circle-state group inline-block">
      {/*
        The click handler must live on this inner wrapper, not the outer div.
        React bubbles clicks through the component tree even for portaled
        content (StateModal renders via Portal into a different DOM node but
        remains a React child here) - if the outer div carried onClick, every
        click inside the open modal (including its own close button) would
        bubble up and call openModal() again, immediately undoing the close.
      */}
      <span onClick={openModal}>
        <ItemCircleState {...circleProps} />
      </span>
      {isOpen && (
        <StateModal
          isVisible={isOpen}
          onClose={closeModal}
          showCancelBtn={false}
          showAcceptBtn={false}
          modalTitle={modalTitle}
          modalSize={modalSize}
        >
          {children}
        </StateModal>
      )}
    </div>
  );
};
